import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import duration from 'dayjs/plugin/duration';

import updateLocale from 'dayjs/plugin/updateLocale';
import advancedFormat from 'dayjs/plugin/advancedFormat';

var rounding = Math.floor;

var thresholds = [
  { l: 's', r: 1 },
  { l: 'ss', r: 599, d: 'second' },
  // { l: 'm', r: 1 },
  { l: 'mm', r: 1439, d: 'minute' },
  // { l: 'h', r: 1 },
  { l: 'hh', r: 119, d: 'hour' },
  // { l: 'd', r: 1 },
  { l: 'dd', r: 29, d: 'day' },
  { l: 'M', r: 1 },
  { l: 'MM', r: 11, d: 'month' },
  { l: 'y', r: 1 },
  { l: 'yy', d: 'year' },
];

var config = {
  thresholds: thresholds,
  rounding: rounding,
};

dayjs.extend(relativeTime, config);
dayjs.extend(duration);

dayjs.extend(updateLocale);
dayjs.extend(advancedFormat);
dayjs.updateLocale('en', {
  relativeTime: {
    future: 'in %s',
    past: '%s ago',
    s: '1 second',
    /* eslint-disable-next-line */
    ss: function (number, withoutSuffix = true, key = 'ss', isFuture = false) {
      if (number < 60) {
        return number + ' seconds';
      } else if (number >= 60 && number < 120) {
        let s = number % 60;
        let plural = s == 1 ? '' : 's';
        return '1 minute ' + s + ' second' + plural;
      } else {
        let m = Math.floor(number / 60);
        let s = number % 60;
        let plural = s == 1 ? '' : 's';
        return m + ' minutes ' + s + ' second' + plural;
      }
    },
    // m: "1 minute",
    /* eslint-disable-next-line */
    mm: function (number, withoutSuffix = true, key = 'mm', isFuture = false) {
      if (number < 60) {
        return number + ' minutes';
      } else if (number >= 60 && number < 120) {
        let m = number % 60;
        let plural = m == 1 ? '' : 's';
        return '1 hour ' + m + ' minute' + plural;
      } else {
        let h = Math.floor(number / 60);
        let m = number % 60;
        let plural = m == 1 ? '' : 's';
        return h + ' hours ' + m + ' minute' + plural;
      }
    },
    // h: "1 hour",
    /* eslint-disable-next-line */
    hh: function (number, withoutSuffix = true, key = 'mm', isFuture = false) {
      if (number < 24) {
        return number + ' hours';
      } else if (number >= 24 && number < 48) {
        let h = number % 24;
        let plural = h == 1 ? '' : 's';
        return '1 day ' + h + ' hour' + plural;
      } else {
        let d = Math.floor(number / 24);
        let h = number % 24;
        let plural = h == 1 ? '' : 's';
        return d + ' days ' + h + ' hour' + plural;
      }
    },
    // d: "1 day",
    dd: '%d days',
    M: '1 month',
    MM: '%d months',
    y: '1 year',
    yy: '%d years',
  },
});

const dayjsExtended = dayjs;

const timestampTime = (timestamp) => {
  return dayjs(timestamp).format('h:mma');
};
const timeStampTimeFull = (timestamp) => {
  return dayjs(timestamp).format('HH:mm');
};
const timestampDate = (timestamp) => {
  return dayjs(timestamp).format('M/D/YY');
};

const getTimeElapsed = (receivedAt) => {
  // const currentTime = new Date();
  // const receivedTime = new Date(receivedAt);
  // const hours = Math.abs(currentTime - receivedTime) / 36e5;
  // const [houres, minutes] = hours.toString().split(".");
  // const minFormat = minutes.slice(0, 2);
  // return getFormat(houres, minFormat);
  return dayjsExtended(receivedAt).fromNow(true); //.replaceAll('years', 'y').replaceAll('weeks', 'w').replaceAll(' months', 'mo').replaceAll(' days', 'd').replaceAll(' hours', 'h').replaceAll(' minutes', 'm').replaceAll(' seconds', 's').replaceAll('a fews ago', 'a few seconds ago');
};

function fromNowFirstUnit(date) {
  const diffInMs = dayjs().diff(dayjs(date));
  const dur = dayjs.duration(diffInMs);

  if (dur.years() > 0)
    return `${dur.years()} year${dur.years() > 1 ? 's' : ''}`;
  if (dur.months() > 0)
    return `${dur.months()} month${dur.months() > 1 ? 's' : ''}`;
  if (dur.days() > 0) return `${dur.days()} day${dur.days() > 1 ? 's' : ''}`;
  if (dur.hours() > 0)
    return `${dur.hours()} hour${dur.hours() > 1 ? 's' : ''}`;
  if (dur.minutes() > 0)
    return `${dur.minutes()} minute${dur.minutes() > 1 ? 's' : ''}`;
  return `${dur.seconds()} second${dur.seconds() > 1 ? 's' : ''}`;
}

// const getFormat = (hours, minutes) => {
//   const min = parseInt(minutes.slice(0, 1));

//   if (min > 5) {
//     const q = parseInt(hours) + 1;
//     let w = parseInt(minutes) - 60;
//     if (w.toString().length === 1) {
//       w = `0${w}`;
//     }
//     return `${q}:${w}`;
//   } else {
//     return `${hours}:${minutes}`;
//   }
// };

export {
  dayjsExtended,
  timestampDate,
  timeStampTimeFull,
  timestampTime,
  getTimeElapsed,
  fromNowFirstUnit,
};
